'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import { motion } from 'framer-motion';
import type React from 'react';
import { forwardRef } from 'react';
import { cn } from '@/frontend/utils';
import { TouchTarget } from '../../actions/Button';
import { Link } from '../../actions/Link';
export interface NavbarItemProps {
  current?: boolean;
  mobile?: boolean;
  className?: string;
  children: React.ReactNode;
}
type NavbarItemButtonProps = NavbarItemProps & Omit<Headless.ButtonProps, 'as' | 'className'>;
type NavbarItemLinkProps = NavbarItemProps & Omit<React.ComponentPropsWithoutRef<typeof Link>, 'className'> & {
  href: string;
};
export const NavbarItem = forwardRef(function NavbarItem(t0, ref) {
  const $ = _c(18);
  let children;
  let className;
  let current;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      current,
      mobile: t1,
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = current;
    $[4] = props;
    $[5] = t1;
  } else {
    children = $[1];
    className = $[2];
    current = $[3];
    props = $[4];
    t1 = $[5];
  }
  const mobile = t1 === undefined ? false : t1;
  let t2;
  if ($[6] !== children || $[7] !== className || $[8] !== current || $[9] !== mobile || $[10] !== props || $[11] !== ref) {
    const classes = cn("relative flex min-w-0 items-center gap-3 rounded-lg p-2 text-left text-base/6 font-medium text-contentPrimary sm:text-sm/5", "*:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5", "*:not-nth-2:last:data-[slot=icon]:ml-auto *:not-nth-2:last:data-[slot=icon]:size-5 sm:*:not-nth-2:last:data-[slot=icon]:size-4", "*:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 *:data-[slot=avatar]:[--avatar-radius:var(--radius-md)] sm:*:data-[slot=avatar]:size-6", "data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950", "data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950", "dark:text-white dark:*:data-[slot=icon]:fill-zinc-400", "dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white", "dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white");
    let t3;
    if ($[13] !== className) {
      t3 = cn(className, "relative");
      $[13] = className;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    let t4;
    if ($[15] !== current || $[16] !== mobile) {
      t4 = current && !mobile && <motion.span layoutId="current-indicator" className="absolute inset-x-2 -bottom-2.5 h-0.5 rounded-full bg-zinc-950 dark:bg-white" />;
      $[15] = current;
      $[16] = mobile;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    t2 = <span className={t3}>{t4}{"href" in props && typeof props.href === "string" ? <Link {...props as NavbarItemLinkProps} className={classes} data-current={current ? "true" : undefined} ref={ref as React.ForwardedRef<HTMLAnchorElement>}><TouchTarget>{children}</TouchTarget></Link> : <Headless.Button {...props as NavbarItemButtonProps} className={cn("cursor-default", classes)} data-current={current ? "true" : undefined} ref={ref}><TouchTarget>{children}</TouchTarget></Headless.Button>}</span>;
    $[6] = children;
    $[7] = className;
    $[8] = current;
    $[9] = mobile;
    $[10] = props;
    $[11] = ref;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
});